// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React, { useState, useRef } from "react";

import List from "./List";
import { Department as StyledDepartment } from "./styles";
import { RelativeBox } from "src/styles/box";

import type { AppState, UserAnalyticsFilter } from "src/types";

type Props = {
  filter: UserAnalyticsFilter
};

const Department = ({ filter }: Props) => {
  const [dropdown, showDropdown] = useState(false);
  const outerRef = useRef(null);

  const department = (filter || {}).department || [];

  return (
    <RelativeBox>
      <StyledDepartment
        ref={outerRef}
        active={dropdown || department.length > 0}
        onClick={showDropdown}
      >
        {i18n.t(k.DEPARTMENT1)}
      </StyledDepartment>
      {dropdown ? (
        <List outerRef={outerRef} handleClose={() => showDropdown(false)} />
      ) : null}
    </RelativeBox>
  );
};

const mapStateToProps = ({ app }: { app: AppState }) => ({
  filter: app.userAnalytics.filter
});

export default connect(mapStateToProps)(Department);
